<template>
  <TheToast />
  <CookiesModal />
  <slot />
</template>

<script lang="ts" setup>
import TheToast from '@backmarket/nuxt-module-toast/TheToast.vue'
import CookiesModal from '@backmarket/nuxt-module-tracking/CookiesModal.vue'
</script>
